import $ from "jquery";
import copy from "copy-to-clipboard";
import queryString from "query-string";

$(document).on("ready", () => {
  // Copy link button
  $(".copy-link-button").on("click", function (e) {
    e.preventDefault();

    const link = $(".share-modal-input").val();
    copy(link);

    const tooltip = $(this).next(".copy-link-tooltip");
    $(tooltip).fadeIn(250).delay(2500).fadeOut(250);
  });

  // Share link button
  $(".share-button").on("click", function (e) {
    e.preventDefault();

    // Prep new modal content
    const shareUrl = location.href.replace(location.hash, "");
    const shareTitle = $(".hero-infobar-text").text();
    const mailToLink = `mailto:?subject=${shareTitle
      .split(" ")
      .join("%20")}&body=${shareUrl}`;

    let shareImage = "";
    const { c: clipId } = queryString.parse(location.search);
    if (clipId) {
      shareImage = $(`.clip-thumb[data-clip-id="${clipId}"]`).data("share-url");
    } else {
      shareImage = WP.eventShareImage;
    }

    // Set new modal content
    $(".share-modal-image").attr("src", shareImage);
    $(".share-modal-title").text(shareTitle);
    $(".share-modal-input").val(shareUrl);
    $(".mail-link-button").attr("href", mailToLink);
  });
});

// Select all text when modal is clicked
let focusedModalInput;
$(".share-modal-input").on("focus", function () {
  if (focusedModalInput == this) return;
  focusedModalInput = this;
  setTimeout(function () {
    focusedModalInput.select();
  }, 100);
});
